import React, { Component } from 'react';
import { connect } from 'react-redux'
import classnames from 'classnames'

import barPaths from '../constants/barPaths'
import gapCapSets from '../constants/gapCapSets'

import { inArray, itemIndex } from '../utilities/'

import tooltips from '../constants/tooltips.json'

import {
	setBarInfoActive,
	setBarInfo,
	selectBar,
	selectGapCap
} from '../actions/'

class MalletStationBars extends Component {
	handleEnter = (e) => {
		const {
			onSetBarInfoActive,
			onSetBarInfo,
			lowNote, octave, gapCaps
		} = this.props

		onSetBarInfoActive(true)
		onSetBarInfo(e.target, lowNote, octave, gapCaps.notes)
	}

	handleLeave = () => {
		this.props.onSetBarInfoActive(false)
	}

	handleClick = (e) => {
		const {
			onSelectBar,
			onSelectGapCap
		} = this.props

		if(~~e.target.id.includes('gap')){
			onSelectBar(~~e.target.dataset.bar)
		} else {
			onSelectBar(-1)
			onSelectGapCap(-1)
		}

		if(e.target.id.includes('gap')) onSelectGapCap(~~e.target.id.replace('gap_', ''))
	}


	render() {
		const {
			gapCaps,
			lowNote,
			selectedBar,
			showTooltips
		} = this.props

		const selectedSet = gapCapSets[lowNote]
		let barID = 0

		return (
			<div
				className='bars-wrapper'
				data-tip={tooltips['editor-bars']}
				data-multiline="true"
				data-place="right"
				data-tip-disable={!showTooltips}
			>
			<svg className="mallet-station-bars" version="1.1" x="0px" y="0px" viewBox="0 0 3157 741.4" onMouseEnter={(e) => this.handleEnter(e)} onMouseLeave={(e) => this.handleLeave(e)} onClick={(e) => this.handleClick(e)}>
				{barPaths.map((bar, index) => {
					barID += (itemIndex(selectedSet, index) !== -1) ? 0 : 1;

					return <path
						id={
							inArray(selectedSet, index)
							? 'gap_' + itemIndex(selectedSet, index)
							: 'bar_' + barID
						}
						data-bar={index}
						key={bar.id}
						className={classnames('bar', {'active': selectedBar === ~~bar.id})}
						data-note={gapCaps.notes[itemIndex(selectedSet, index)]}
						d={bar.d}></path>
				})}
			</svg>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
  return {
    gapCaps: state.currentPreset.gapCaps,
		lowNote: state.currentPreset.lowNote,
		octave: state.currentPreset.octave,
		selectedBar: state.editor.selectedBar,
		selectedGapCap: state.editor.selectedGapCap,
		showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
		onSetBarInfoActive: (active) => {
			dispatch(setBarInfoActive(active))
		},
		onSetBarInfo: (bar, lowNote, octave, gapCaps) => {
			dispatch(setBarInfo(bar, lowNote, octave, gapCaps))
		},
		onSelectBar: (bar) => {
			dispatch(selectBar(bar))
		},
		onSelectGapCap: (cap) => {
			dispatch(selectGapCap(cap))
		}
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MalletStationBars)
